export default __webpack_public_path__ + "static/media/cockpit-Header-Tablet.6bc2deba.jpg";